import { assert_is_safe_number } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class DTO__position extends DTO__base {
  /*
   * STATIC FIELDS
   */
  static readonly _class_name_static: string = ENUM__dto_class_name.POSITION;

  static readonly ZERO = new DTO__position(0, 0);

  /*
   * FIELDS
   */
  x: number;
  y: number;

  /*
   * METHODS
   */

  constructor(x: number = CONSTANTS__shared.NUMBER_EMPTY_VALUE, y: number = CONSTANTS__shared.NUMBER_EMPTY_VALUE) {
    super();

    this.x = x;
    this.y = y;
  }

  assert_standard_fields(): void {
    assert_is_safe_number(this.x);
    assert_is_safe_number(this.y);
  }

  add(other: DTO__position): DTO__position {
    return new DTO__position(this.x + other.x, this.y + other.y);
  }

  isEqual(other: DTO__position): boolean {
    return this.x == other.x && this.y == other.y;
  }
}
